import { render, staticRenderFns } from "./mingyiManage.vue?vue&type=template&id=42cd0672&scoped=true&"
import script from "./mingyiManage.vue?vue&type=script&lang=js&"
export * from "./mingyiManage.vue?vue&type=script&lang=js&"
import style0 from "./mingyiManage.vue?vue&type=style&index=0&id=42cd0672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd0672",
  null
  
)

export default component.exports